import { getSupplierEventQuestionFieldName } from '@bridebook/ui';
import { ISupplierCalendarQuestion } from '@bridebook/models/source/models/Suppliers/Calendars.types';
import { TFunction } from 'next-i18next';
import { z } from 'zod';

/**
 * Answer fields for a venue's showround questions, keyed by the question field names. Shared by
 * every showround booking form, so required answers follow the same rule and error copy.
 */
export const getQuestionAnswersShape = (
  questions: Pick<ISupplierCalendarQuestion, 'required'>[],
  t: TFunction,
): Record<string, z.ZodTypeAny> =>
  Object.fromEntries(
    questions.map((question, index) => [
      getSupplierEventQuestionFieldName(index),
      question.required
        ? z.string().trim().min(1, t('enquiries:validation.required'))
        : z.string().optional(),
    ]),
  );
